import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions.js";
import Row from "../layout/Row.js";
import Column from "../layout/Column.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import MLTFGPT2 from "../textfields/MLTFGPT2.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import modifyClient from "../api/modify/modifyClient.js";
import { useSnackbar } from "notistack";
import { useAppContext } from "../config/AppContext.js";
import { Switch } from "@mui/material";
import checkPageAccess, { checkPageAccessV2 } from "../auth/checkPageAccess.js";
import DropDownGPT0 from "../dropdowns/DropDownGTP0.js";
import { set } from "date-fns";
import SmallSpinner from "../loading/SmallSpinner.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import TextField2T from "../textfields/TextField2T.js";
import { ToggleSettingsBrick } from "../textfields/EasySwitch.js";
import modifyPartner from "../api/modify/modifyPartner.js";
import { getCommunWorkspace } from "./folder_pages/FolderHelpers.js";
function ModifyPartner({
  userData,
  orgData,
  navigateWorkspace,
  workspaceData,
}) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const { currentUser, loading } = useAuth();

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [partner_type, setPartnerType] = useState();
  const [payment_allowed, setPaymentAllowed] = useState(false);

  const type_options = [
    { value: "constructor", label: "Constructeur" },
    { value: "promotor", label: "Promoteur" },
    { value: "architect", label: "Architecte" },
    { value: "artisan", label: "Artisan" },
    { value: "prospect", label: "Prospect" },

    { value: "mdo", label: "Maître d'oeuvre" },
    { value: "drawer", label: "Dessinateur" },
    { value: "expert", label: "Bureau d'étude" },
    { value: "infiltro", label: "Infiltromètre" },
    { value: "travaux", label: "Entreprise de travaux" },
    { value: "agence_immobilier", label: "Agence immobilière" },
    { value: "mar", label: "MAR" },
    { value: "other", label: "Autre" },
  ];

  const [entreprise, setEntreprise] = useState("");
  const [siren, setSiren] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [ville, setVille] = useState("");
  const [postal, setPostal] = useState("");
  const [adresse, setAdresse] = useState("");

  const [partnerData, setPartnerData] = useState(null);
  const [partnerWorkspace, setPartnerWorkspace] = useState(null);
  // Fetch user, org, clients, and client data
  const handleFetchData = async () => {
    if (userData) {
      try {
        // Fetch user data
        if (
          (await checkPageAccessV2(
            userData,
            orgData,
            workspaceData,
            "basic"
          )) == false
        ) {
          navigateWorkspace("/home");
        }

        // Fetch organization data using user's org reference

        // Fetch client data based on the id from the URL
        const partner = await getOrgById(id);
        let partner_workspace = await getCommunWorkspace(partner, orgData);
        setPartnerData(partner);
        setPartnerWorkspace(partner_workspace);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if (currentUser) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser]); // Dependency array ensures this runs when currentUser changes

  // Fill form with clientData once it's fetched
  useEffect(() => {
    if (partnerData) {
      setPartnerType(partnerData.partner_type); // Assuming `clientData.type` holds the client type
      setPaymentAllowed(partnerWorkspace?.permissions?.payment_allowed); // Assuming `clientData.type` holds the client type

      setEntreprise(partnerData.name || ""); // Assuming `clientData.entreprise` holds the company name
      setPhone(partnerData.phone || ""); // Assuming `clientData.phone` holds the phone number
      setEmail(partnerData.email || ""); // Assuming `clientData.email` holds the email address
      setVille(partnerData.infos.ville || ""); // Assuming `clientData.ville` holds the city
      setPostal(partnerData.infos.postal || ""); // Assuming `clientData.postal` holds the postal code
      setAdresse(partnerData.infos.adresse || ""); // Assuming `clientData.adresse` holds the address
      setSiren(partnerData.infos.siren || ""); // Assuming `clientData.siren` holds the SIREN number
    }
  }, [partnerData, partnerWorkspace]); // Only run this when clientData changes
  const [loadingData, setLoadingData] = useState(false);
  // Function to update the client
  const callmodifyPartner = async () => {
    if (!userData || !orgData) return;
    setLoadingData(true);

    try {
      // Get the user's Firebase authentication token
      const token = await currentUser.getIdToken(); // Fetch token from Firebase
      const result = await modifyPartner(
        phone, // Phone number
        ville, // City
        postal,
        entreprise, // Company name
        partner_type, // Client type
        payment_allowed, // Client type 2
        partnerData.id, // Organization ID
        adresse, // Address
        siren, // SIREN number
        email, // Email address
        token, // Firebase Authentication token
        prefix
      );

      if (result && result.ok) {
        handleClickVariant("Partenaire modifié avec succès", "success");
        navigateWorkspace("/partner/" + partnerData.id); // Navigate back to the partner page
      } else {
        const status = result?.status ?? "?";
        const detail = result?.body ? ` – ${result.body}` : "";
        console.error("modifyPartner failed:", result);
        handleClickVariant(
          `Échec de la modification du partenaire (${status})${detail}`,
          "error"
        );
      }
    } catch (error) {
      console.error("Error modifying partner:", error);
      handleClickVariant(
        `Erreur lors de la modification : ${error.message}`,
        "error"
      );
    }
    setLoadingData(false);
  };

  if (loading || !currentUser || !userData) {
    return <div></div>; // Show loading state while checking auth or if currentUser is null
  }

  return (
    <Row className="w-full h-full overflow-auto flex">
      {/* Left Column: Takes all available space */}

      {/* Right Column: Fixed width */}
      <Column align="left" className="h-full max-w-c400 pl-4">
        <Space y={20} />
        <div className="text-h1 font-semibold">Modifier partenaire</div>
        <Space y={5} />
        <Column align="left" className="w-full pr-2" y={10}>
          <DropDownGPT03
            items={type_options}
            className="w-full"
            label="Catégorie"
            value={partner_type} // Controlled component
            onChange={(e) => setPartnerType(e.value)}
            mandatory={true}
          ></DropDownGPT03>
          <TextField2T
            className="w-full"
            label="Entreprise"
            value={entreprise}
            onChange={(e) => setEntreprise(e.target.value)}
            mandatory={true}
          ></TextField2T>{" "}
          <TextField2T
            className="w-full"
            type="siren"
            label="SIREN"
            value={siren}
            onChange={(e) => setSiren(e.target.value)}
            mandatory={false}
          ></TextField2T>
          <TextField2T
            label="Téléphone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            mandatory={true}
            type="phone"
          ></TextField2T>
          <TextField2T
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            mandatory={false}
            type="email"
          ></TextField2T>
          <TextField2T
            label="Ville"
            value={ville}
            onChange={(e) => setVille(e.target.value)}
            mandatory={true}
          ></TextField2T>
          <TextField2T
            label="Code Postal"
            value={postal}
            onChange={(e) => setPostal(e.target.value)}
            mandatory={true}
          ></TextField2T>
          <TextField2T
            label="Adresse"
            value={adresse}
            onChange={(e) => setAdresse(e.target.value)}
            mandatory={true}
          ></TextField2T>{" "}
          {!["infiltro", "expert"].includes(partner_type) && (
            <ToggleSettingsBrick
              title="Utiliser le paiement particulier pour ce client"
              description={
                "Si activé, il sera possible de créer des paiements dans les dossiers de ce client et les rapports lui seront débloqués automatiquement lorsque le particulier paye."
              }
              checked={payment_allowed}
              onChange={(checked) => {
                setPaymentAllowed(checked);
              }}
            ></ToggleSettingsBrick>
          )}
        </Column>
        <Space y={10} />

        <div className="w-full flex flex-row-reverse">
          <PrimaryButton onClick={callmodifyPartner}>
            <div className="flex flex-row content-center">
              <Space x={5} />
              Modifier partenaire
              <SmallSpinner loading={loadingData} color="white" size={20} />
            </div>
          </PrimaryButton>
        </div>
      </Column>
    </Row>
  );
}

export default ModifyPartner;
